import React from 'react';
import PropTypes from 'prop-types';
import env from './env';

import resources from '../resources/resources';
import * as constants from './uiconstants';

let lang = env.getLanguage();
export let currentResource = resources(lang);
export let labels = currentResource.labels;
export let LocalizedUIConstants = constants;

let updateConstantsWithLocale = (prop) => {
	prop.map((p) => {
		p['localizedlabel'] = currentResource[p.label] || p.label;
		return p;
	});
	return prop;
};

/*set user selected language*/
export const setLanguage = (language) => {
	if (language) {
		currentResource = resources(language);
		labels = currentResource.labels;
	}
	let constantCollections = _.pickBy(LocalizedUIConstants, (c) => _.isArray(c) && _.isObject(c[0]));
	LocalizedUIConstants = _.forEach(constantCollections, updateConstantsWithLocale);
};

/*Retrieves the token from the local storage, and attempts to parse its payload into a JSON object. Returns that object if succesful, and null if it failed.*/
// export const retrieveDecodedTokenPayload = () => {
// 	try {
// 		const token = localStorage.getItem('adal.idtoken');
// 		console.log("LC_log: ", token);
// 		return JSON.parse(atob(token.split('.')[1]));
// 	} catch (error) {
// 		return null;
// 	}
// };

export const childrenPropTypes = PropTypes.oneOfType([
	PropTypes.arrayOf(PropTypes.node),
	PropTypes.node
])